/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Kpi_VolumeInputs */

const cs_dashboard_kpi_volume = /** @type {(inputs: Dashboard_Kpi_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzavřený objem`)
};

const en_dashboard_kpi_volume = /** @type {(inputs: Dashboard_Kpi_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed volume`)
};

/**
* | output |
* | --- |
* | "Closed volume" |
*
* @param {Dashboard_Kpi_VolumeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_kpi_volume = /** @type {((inputs?: Dashboard_Kpi_VolumeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Kpi_VolumeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_kpi_volume(inputs)
	return cs_dashboard_kpi_volume(inputs)
});